'use strict';

module.exports = ['$sce',
	function ($sce) {

		function parseTweet(tweet) {
			let newTweet = {};

			newTweet.message = {
				original_text: tweet.text,
				photos: [],
				audio: [],
				videos: [],
			};

			if (tweet.extended_entities && tweet.extended_entities.media){
				tweet.extended_entities.media.forEach((media) => {
					tweet.text = tweet.text.replace(media.url, '');
					if(media.type == 'photo') {
						newTweet.message.photos.push(media.media_url_https);
					} else if(media.type == 'video') {
						newTweet.message.videos.push(media.media_url_https);
					}
				});
			}

			if (tweet.entities.urls){
				tweet.entities.urls.forEach((url) => {
					tweet.text = tweet.text.replace(url.url, '<a target="_blank" href="'+url.expanded_url+'">'+url.display_url+'</a>');
				});
			}
			if (tweet.entities.hashtags){
				tweet.entities.hashtags.forEach((hashtag) => {
					tweet.text = tweet.text.replace('#' + hashtag.text, '<a target="_blank" href="https://twitter.com/hashtag/' + hashtag.text +'" style="color:#0084B4;">#'+hashtag.text+'</a>');
				});
			}
			if (tweet.entities.user_mentions){
				tweet.entities.user_mentions.forEach((mention) => {
					tweet.text = tweet.text.replace('@' + mention.screen_name, '<a target="_blank" href="https://twitter.com/' + mention.screen_name + '" style="color:#0084B4;">@'+mention.screen_name+'</a>');
				});
			}

			newTweet.message_id = tweet.id;
			newTweet.message.text = tweet.text;
			newTweet.avatar_url = tweet.user.profile_image_url_https;
			newTweet.sender_id = tweet.user.screen_name;
			newTweet.sender_name = tweet.user.name;
			newTweet.external_url = 'https://twitter.com/statuses/' + tweet.id_str;
			newTweet.message_date = new Date(tweet.created_at);

			//special values used for design of tweets
			newTweet.is_retweet = !!tweet.retweeted_status;
			return newTweet;
		}

		function parsePost(post) {
			let _message = post.message;
			post.message = {
				text: _message,
				photos: [],
				audio: [],
				videos: [],
			};
			post.message_date = new Date(post.created_at);
			return post;
		}

		function parseExternal(external) {
			external.message.original_text = external.message.text;
			// http://, https://, ftp://
			var urlPattern = /\b(?:https?|ftp):\/\/[a-z0-9-+&@#\/%?=~_|!:,.;]*[a-z0-9-+&@#\/%=~_|]/gim;
			external.message.text = external.message.text.replace(urlPattern, '<a target="_blank" href="$&">$&</a>');
			external.message_date = external.message_date ? new Date(external.message_date) : new Date();
		}

		return {
			restrict: 'E',
			scope: {
				data: '=messageData',
				model: '=model',
				type: '=type',
				noPicture: '=noPicture',
				deleteCallback: '&deleteCallback',
				noMenu: '=',
			},
			templateUrl: '/partial/app.directives.social_message',
			link: function (scope, element, attributes) {
				if(scope.noMenu) {
					element.addClass('no-menu');
				}
				scope.hoverClass = '';
				let type = !!scope.type ? scope.type : scope.model.name;
				switch (type) {
					case 'Twitter':
						scope.data = parseTweet(scope.data);
						break;
					case 'Facebook':
						parsePost(scope.data);
						break;
					case 'already_parsed':
						break;
					default:
						parseExternal(scope.data);
						break;
				}

				scope.timeToHuman = (time) => {
					return moment.duration(moment(time).diff()).humanize(true);
				};

			}
		};
	}
];

